import axios from "axios";

export default {
  namespaced: true,
  state: () => ({
    isLoggedIn: false,
    data: null
  }),
  mutations: {
    setLoggedIn(state, payload) {
      state.isLoggedIn = true;
      state.data = payload;
    },
    setLoggedOut(state) {
      state.isLoggedIn = false;
      state.data = null;
    }
  },
  actions: {
    setUser(context) {
      return new Promise(resolve => {
        axios
          .get("v1/user")
          .then(response => {
            context.commit("setLoggedIn", response.data);
            resolve(true);
          })
          .catch(response => {
            context.commit("setLoggedOut", response.data);
            resolve(true);
          });
      });
    },
    loginUser(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post("login", { email: payload.email, password: payload.password })
          .then(response => {
            context.dispatch("setUser");
            resolve(response);
          })
          .catch(response => {
            reject(response);
          });
      });
    },
    logoutUser(context) {
      context.commit("setLoggedOut");
      return axios.post("logout");
    }
  },
  getters: {}
};
